import Typography from "@material-ui/core/esm/Typography";
import clsx from 'clsx';
import React from 'react';
import useStyles from './TextStyles';
export default function BoldSubtitle({
  children,
  align,
  className,
  id,
  htmlFor,
  component = 'strong'
}) {
  const {
    bold
  } = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    align: align,
    variant: "subtitle1",
    className: clsx(bold, className),
    component: component,
    id: id,
    htmlFor: htmlFor
  }, children);
}
BoldSubtitle.defaultProps = {
  align: 'left',
  component: 'strong'
};